/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useLazyGetCitiesQuery } from "../../services/profile";
import { showError } from "../../constants/toasts";
export interface City {
  city: string;
  city_ar: string;
  country: string;
  country_ar: string;
  currency: string;
  cur_symbol: string;
  id: number;
  city_en: string;
  country_en: string;
}

const LookingForTravellersFilter = ({
  setSelectedDepartureCities,
  setSelectedArrivalCities,
  arrivalCities,
  departureCities,
  setFilterData,
}: any) => {
  const [getCities] = useLazyGetCitiesQuery();
  const [selectField1, setSelectField1] = React.useState("");

  const [selectField2, setSelectField2] = React.useState("");

  const [selectField3, setSelectField3] = React.useState<any>(-1);
  const handleChange3 = (event: SelectChangeEvent) => {
    setSelectField3(event.target.value);
  };

  const [selectField4, setSelectField4] = React.useState<any>(-1);
  const handleChange4 = (event: SelectChangeEvent) => {
    setSelectField4(event.target.value);
  };
  const [city, setCities] = useState<City[]>([]);
  console.log("city :", city);
  const countryFrom = [
    "Ottawa, Canada",
    "Riyadh, Saudi Arab",
    "Canberra, Australia",
    "Lahore, Pakistan",
  ];
  const countryTo = [
    "Ottawa, Canada",
    "Riyadh, Saudi Arab",
    "Canberra, Australia",
    "Lahore, Pakistan",
  ];
  const getCitiesData = async () => {
    try {
      const response = await getCities({}).unwrap();
      if (response.statusCode == 200) {
        setCities(response?.data);
      }
    } catch (error: any) {
      showError("Get Cities api failed");
    }
  };
  useEffect(() => {
    getCitiesData();
  }, []);
  return (
    <>
      <div className="table_header select_filter">
        <div className="d_flex">
          <Autocomplete
            disablePortal
            id="countryFrom"
            options={[
              ...city?.map((data: any) => data?.city + ", " + data?.country),
              ...city?.map(
                (data: any) => data?.city_ar + ", " + data?.country_ar
              ),
            ]}
            // options={departureCities?.map(
            //   (data: any) => data?.name + ", " + data?.country
            // )}
            value={selectField1}
            inputValue={selectField1}
            onChange={() => {}}
            onInputChange={(event, newInputValue) => {
              setSelectField1(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Country From" />
            )}
          />
          <Autocomplete
            disablePortal
            id="countryFrom"
            options={[
              ...city?.map((data: any) => data?.city + ", " + data?.country),
              ...city?.map(
                (data: any) => data?.city_ar + ", " + data?.country_ar
              ),
            ]}
            // options={arrivalCities?.map(
            //   (data: any) => data?.name + ", " + data?.country
            // )}
            value={selectField2}
            inputValue={selectField2}
            onInputChange={(event, newInputValue) => {
              setSelectField2(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Country To" />
            )}
          />
          <Select
            fullWidth
            labelId="baggage_type"
            id="baggage_type"
            value={selectField3}
            onChange={handleChange3}
          >
            <MenuItem disabled value={-1}>
              Type of Baggage
            </MenuItem>
            <MenuItem value={1}>Envelop</MenuItem>
            <MenuItem value={2}>Carton</MenuItem>
            <MenuItem value={3}>Suitcase</MenuItem>
            <MenuItem value={4}>Box</MenuItem>
            <MenuItem value={5}>Barrel</MenuItem>
            <MenuItem value={6}>Toys, Furniture, Tools & Others</MenuItem>
          </Select>
          {/* <Select
            fullWidth
            labelId="travel_category"
            id="travel_category"
            value={selectField4}
            onChange={handleChange4}
          >
            <MenuItem disabled value={-1}>
              Category
            </MenuItem>
            <MenuItem value={1}>
              Pharmaceutical & Health care products and books
            </MenuItem>
            <MenuItem value={2}>Beauty & Perfumes</MenuItem>
            <MenuItem value={3}>Cloths</MenuItem>
            <MenuItem value={4}>Foodstuf</MenuItem>
            <MenuItem value={5}>
              Mobile, Tablet, Laptop and accessories
            </MenuItem>
            <MenuItem value={6}>Home tools, Furniture and toys</MenuItem>
            <MenuItem value={7}>Documents and printed matter</MenuItem>
            <MenuItem value={8}>other</MenuItem>
          </Select> */}
        </div>
        <Button
          className="btn btn_primary"
          style={{
            minWidth: "100px",
            backgroundColor: "white",
            color: "black",
            fontSize: "12px",
            padding: "0",
          }}
          onClick={() => {
            setSelectField2("");
            setSelectField1("");

            setSelectField4(-1);
            setSelectField3(-1);
            setFilterData({
              countryFrom: "",
              countryTo: "",
              baggage: -1,
              category: -1,
            });
          }}
        >
          Clear Filter
        </Button>

        <Button
          className="btn btn_secondary"
          onClick={() => {
            if (
              (selectField1 &&
                !city?.some(
                  (data) =>
                    (data?.city + ", " + data?.country)
                      ?.trim()
                      ?.toLocaleLowerCase() ==
                    selectField1?.trim()?.toLocaleLowerCase()
                )) ||
              (selectField2 &&
                !city?.some(
                  (data) =>
                    (data?.city + ", " + data?.country)
                      ?.trim()
                      ?.toLocaleLowerCase() ==
                    selectField2?.trim()?.toLocaleLowerCase()
                ))
            ) {
              showError("Please Choose City from List");
              return;
            }
            setFilterData({
              countryFrom:
                city?.find(
                  (data) =>
                    (data?.city + ", " + data?.country)
                      ?.trim()
                      ?.toLocaleLowerCase() ==
                    selectField1?.trim()?.toLocaleLowerCase()
                )?.id || "",
              countryTo:
                city?.find(
                  (data) =>
                    (data?.city + ", " + data?.country)
                      ?.trim()
                      ?.toLocaleLowerCase() ==
                    selectField2?.trim()?.toLocaleLowerCase()
                )?.id || "",
              baggage: selectField3,
              category: selectField4,
            });
          }}
        >
          Search
        </Button>
      </div>
    </>
  );
};

export default LookingForTravellersFilter;
